import { 
    Container, 
    Box, 
    AppBar, 
    Toolbar, 
    Typography, 
    Paper, 
    Button, 
    Avatar,
    Menu,
    MenuItem,
    Chip
} from '@mui/material';
import { LogoutOutlined as LogoutIcon } from '@mui/icons-material';
import { type ReactNode, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface MainLayoutProps {
    children: ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
    const { user, signOut, isAdmin } = useAuth();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleUserMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleUserMenuClose = () => {
        setAnchorEl(null);
    };

    const handleSignOut = async () => {
        try {
            await signOut();
            handleUserMenuClose();
        } catch (error) {
            console.error('Sign out error:', error);
        }
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                        <img 
                            src="/offshoreSailsLogo.ico" 
                            alt="Offshore Sails Online" 
                            style={{ height: '32px', width: '32px', marginRight: '12px' }}
                        />
                        <Typography variant="h6" component="div">
                            Offshore Sails Online
                        </Typography>
                    </Box>
                    
                    {user && (
                        <>
                            {isAdmin && (
                                <Chip 
                                    label="Admin" 
                                    color="secondary" 
                                    size="small" 
                                    sx={{ mr: 2, color: 'white', borderColor: 'white' }}
                                    variant="outlined"
                                />
                            )}
                            
                            <Button
                                color="inherit"
                                onClick={handleUserMenuOpen}
                                startIcon={
                                    <Avatar 
                                        src={user.photoURL || undefined} 
                                        sx={{ width: 32, height: 32 }}
                                    >
                                        {user.name.charAt(0).toUpperCase()}
                                    </Avatar>
                                }
                            >
                                {user.name || user.email}
                            </Button>
                            
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleUserMenuClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <MenuItem onClick={handleSignOut}>
                                    <LogoutIcon sx={{ mr: 1 }} />
                                    Sign Out
                                </MenuItem>
                            </Menu>
                        </>
                    )}
                </Toolbar>
            </AppBar>
            
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Paper
                    elevation={3}
                    sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '70vh'
                    }}
                >
                    {children}
                </Paper>
            </Container>
        </Box>
    );
};